import * as yup from 'yup';
import { HouseDivisionType, values } from '../enums';

export const HouseDivisionSchema = yup.object({
  type: yup.mixed<HouseDivisionType>().oneOf(values(HouseDivisionType)).required(),
  name: yup.string().required(),
  parentId: yup.string().nullable(),
  residentId: yup.string().nullable(),
  label: yup.string().nullable(),
  remark: yup.string().notRequired().nullable(),
});

export interface IHouseDivision {
  type: HouseDivisionType;
  name: string;
  parentId?: string;
  residentId?: string;
  label?: string;
  remark: string | null;
}

export const UpdateHouseDivisionSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(HouseDivisionSchema);

export interface IUpdateHouseDivision extends IHouseDivision {
  id: string;
}
